export var ConditionOperatorId;
(function (ConditionOperatorId) {
    ConditionOperatorId["Exists"] = "exists";
})(ConditionOperatorId || (ConditionOperatorId = {}));
